// Identificadores fixos do documento "Resumo do Requerimento" (PDF gerado
// automaticamente, ver resumoRequerimentoService.js). Isolados aqui, num
// arquivo SEM NENHUM import, porque documentoAnexoRequerimentoService.js só
// precisa desses 2 valores — importar do resumoRequerimentoService.js
// puxaria o jsPDF real (que quebra o Jest com "TextEncoder is not defined"
// quando carregado sem mock — mesmo motivo pelo qual dadosRequerimentoConfigUtils.js
// foi separado do axios em outra sessão).
export const RESUMO_REQUERIMENTO_DOC_ID = '__resumoRequerimento';
export const RESUMO_REQUERIMENTO_TIPO_DOCUMENTO_PROCESSO = 73;
